import React from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';

const NotFound = () => {
  const { t: translate } = useTranslation();

  return (
    <div
      className={`d-flex flex-column w-100 ${
        isBrowser ? 'h-85vh' : 'h-65vh'
      } justify-content-center align-items-center`}>
      <div>
        <img className="w-100" src="./assets/images/warning.png" alt="Success" />
      </div>
      <div className={`text-center mt-4 pt-2 ${isBrowser ? 'w-50' : 'px-3'}`}>
        <p className="text-f5 text-bold letter-spacing-2" style={{ lineHeight: '24px' }}>
          {translate('page_note_found_title')}
        </p>
        <p className="text-f6 letter-spacing-3 mt-3" style={{ lineHeight: '16px' }}>
          {translate('page_note_found_note')}
        </p>
      </div>
    </div>
  );
};

export default NotFound;
